import styled from "styled-components";
import { Select as SemanticSelect } from "semantic-ui-react";

export const Container = styled.div`
  width: 100%;
  padding: 20px;
  margin-left: -50px;
  max-width: 1440px !important;
  overflow: scroll;
`;

export const CenterCont = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const Title = styled.p`
  font-size: 24px;
  position: relative;
  margin-bottom: 20px;
  font-weight: 800;
`;

export const InputAlign = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
`;

export const InputAlignRow1 = styled.div`
  width: 90%;
`;

export const InputAlignRow2 = styled.div`
  width: 8%;
  margin-left: 2%;
`;

export const Subtitle = styled.h2`
  font-size: 16pt;
`;

export const Select = styled(SemanticSelect)`
  margin-bottom: 16px;
`;
